/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import ProfileModel from './ProfileModel';

export interface SharedOwnerNotificationInterface {
  id: number;
  user_id: number;
  type: string;
  active: number;
  create_at: string;
  updated_at: string;
  shared_owner?: SharedOwnerInterface;
}

export interface SharedOwnerInterface {
  email: string;
  state: string;
  primary: number;
  health_entry_count?: number;
  health_entry_last_update?: string;
  additional_owners: string[];
  requestor_profile: any;
  shared_profile: any;
}

class SharedOwnerNotificationModel {

  data: SharedOwnerNotificationInterface;

  constructor(data: SharedOwnerNotificationInterface) {
    this.data = _.assign({
      id: null,
      user_id: null,
      type: '',
      active: null,
    }, data);
  }

  get id() {
    return this.data.id;
  }

  get email() {
    return this.data.shared_owner.email;
  }

  get additionalOwners() {
    return this.data.shared_owner.additional_owners;
  }

  get healthEntryCount() {
    return this.data.shared_owner.health_entry_count;
  }

  get healthEntryLastUpdated() {
    return this.data.shared_owner.health_entry_last_update;
  }

  get lastUpdated() {
    return this.data.updated_at;
  }

  get requestorProfile() {
    const requestorProfile = _.get(this, 'data.shared_owner.requestor_profile', {});
    return new ProfileModel(requestorProfile);
  }

  get sharedProfile() {
    const sharedProfile = _.get(this, 'data.shared_owner.shared_profile', {});
    return new ProfileModel(sharedProfile);
  }

  get isSelfInvitation() {
    return this.data.shared_owner.primary === 1;
  }

  get isSharedProfileRequestorProfile() {
    return this.data.shared_owner.shared_profile.id === this.data.shared_owner.requestor_profile.id;
  }

  get isRelevantToApplication() {
    return this.data.type !== 'group_admin';
  }
}

export default SharedOwnerNotificationModel;
